console.log("personalizer-modal-cart-liquid.js.liquid loaded");
var personalizerModlIsOpen = false;
var price = null;
var currency;
var modalActiveClass = "is-modal-personalizer-active";

var divZindexNegative = '.Product__ActionList,'+
    '.ProductList--carousel,'+
    'a.spr-summary-actions-newreview,'+
    '.Product__SlideshowNav--dots,'+
    'ul.Footer__PaymentList,'+
    'ul.Linklist,'+
    'span.Icon-Wrapper--clickable,'+
    'li.Linklist__Item,'+
    '.Product__SlideshowNav--thumbnails';

var divHideShow = '.Product__Gallery,'+
    '.ProductListWrapper,'+ 
    '.Footer__Aside, '+
    '.Footer__Content Rte,'+
    '#shopify-product-reviews,'+
    '#shopify-section-footer';

$('.personalize-form-input').attr("disabled", true);

function showModal(e) {
  _targetModal = $(e.target).data("modalPersonalizerTrigger");
  $(_targetModal).addClass(modalActiveClass);
  $(divHideShow).hide();
  $('.personalize-form-input').removeAttr("disabled"); 
  $(".imgareaselect-selection").parent().show();
  $(".imgareaselect-outer").show();
  $(divZindexNegative).css('z-index', '-1!important');
  setTimeout(function() { 
    $("#modal-titleContent").html(
      "Isidore Leroy - "+ $(".ProductMeta__Title.Heading.u-h2").first().html()
      //+ " - "+  $(".ProductMeta__Price").first().html()
    );
  }, 500);


  personalizerModlIsOpen = true;
  initData();
}

function hideModal(e) {
  _targetModal = $(e.target).data("modalPersonalizerDismiss");
  if(!_targetModal){
    _targetModal = "#customPaper-modal";
  }
  $(_targetModal).removeClass(modalActiveClass);
  $(divHideShow).show();          

  $(".imgareaselect-selection").parent().hide();
  $(".imgareaselect-outer").hide();
  $(divZindexNegative).css('z-index', '');
  initTrigger();
  /*
            $('.personalize-form-input').attr("disabled", true);
            $('.personalize-form-input').val();
            x_wall.val('');
            y_wall.val('');
            */
  personalizerModlIsOpen = false;
  window.location.reload();

}

function initTrigger() {
  $(".modal-personalizer-trigger").off("click", showModal);
  $(".modal-personalizer-trigger").on("click", showModal);
  $(".personalizer_close_action").off('click', hideModal);
  $(".personalizer_close_action").on('click', hideModal);
  $(".ProductForm__AddToCart").off('click', hideModal);
  $(".ProductForm__AddToCart").on('click', hideModal);
};


//hide unit price and quantity on cart
var alreadyUpdate;

$(document).on('pageinit', function() {
  console.warn("pageinit");
  	//initTrigger();
  	if(!alreadyUpdate){
	  alreadyUpdate = true;
      hideQuantity(true);
    }
      
});

function hideQuantity(updateNumber){
	$('.CartItem').each(function(index){
          if($( this ).text().indexOf("Sur-mesure: oui") >= 0 
             || $( this ).text().indexOf("Sur-mesure:oui") >= 0){
            console.warn("cache quantité");
            	hideHeaderCartMenuQuantity();
             	forceHideCartItemQuantity(this);
              var $quantity = $( this ).children('div.CartItem__Actions').children('div.CartItem__QuantitySelector').children('div.QuantitySelector');
              if(!$quantity.length){
                  $quantity = $( this ).children('.CartItem__Info').children('div.CartItem__Actions').children('div.CartItem__QuantitySelector').children('div.QuantitySelector');
              }

              var quantity = parseInt($('span.Header__CartCount').text()) - parseInt($quantity.children('.QuantitySelector__CurrentQuantity').val());
              $quantity.hide();
              if(!isNaN(quantity) && updateNumber === true){
                   $('span.Header__CartCount').text(quantity+1);
              }

              $( this ).children('.CartItem__Info').children('div.CartItem__Meta').children('div.CartItem__PriceList').children('span.CartItem__Price').hide();
          }
      });
};

function hideHeaderCartMenuQuantity() {
  var $parent = $(".Header__CartCount").parent();
 $(".Header__CartCount").remove();
  if($parent && $parent.html()) {
    $parent.html($parent.html().replace('()',''));
  }
}

//fix for mobile
function forceHideCartItemQuantity(that){
   $( that ).find(".CartItem__QuantitySelector").hide();
}

hideQuantity();
setInterval(hideQuantity, 1000);

function hideQuantityInterval(index){
  if(isNaN(index)){
  	index = 1;
  }
  if(index < 40){
  	setTimeout(hideQuantity, 250*index);
    hideQuantityInterval(++index);
  }

};

$(".CartItem__Remove").off("click", hideQuantityInterval);
$(".CartItem__Remove").on("click", hideQuantityInterval);

//# sourceURL=isidore-cart-customoizer.js